// extracted by mini-css-extract-plugin
export var root = "author-list-module--root--ePVy7";
export var headline = "author-list-module--headline--cvfcH undefined";
export var list = "author-list-module--list--EgLeg";
export var listItem = "author-list-module--listItem--gBKgf";
export var avatar = "author-list-module--avatar--Piz-O";